import { render, staticRenderFns } from "./ItemFilterCreationUserLayout.vue?vue&type=template&id=493d39b1&scoped=true&"
import script from "./ItemFilterCreationUserLayout.vue?vue&type=script&lang=js&"
export * from "./ItemFilterCreationUserLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493d39b1",
  null
  
)

export default component.exports